import React from 'react';
import {
    withStyles,
    Grid,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import NoMatch from './NoMatch';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';
import PreviewTwoItem from '../view/PreviewTwoItem';
import AppData from '../../model/AppData';

class MoreRecomm extends React.Component {
    constructor(props) {
        super(props);
 
        let data = props.location.data;
       
        if (!data) {
            data = AppUtils.getStorageObj('MoreRecommData');
        }
        AppUtils.setStorageObj('MoreRecommData', data)

        this.state = {
            data: [],
            param: data,
        };
        document.body.style.overflow = 'scroll';
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'MoreRecomm');
        this.getTypeHostRecomm();
        document.body.style.overflow = 'scroll';
        let { os } = this.props.match.params;
        if (os && os != '') {
            AppData.os = os
        }
        else {
            AppData.os = 'h5'
        }
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getTypeHostRecomm = async () => {
        const { param } = this.state;
        console.log('datas==>',param);
        if (param) {
            let result = await Apis.encryptionTypeHostRecomm(param.type);
            console.log('getTypeHostRecomm', result);
            if (result.code == 200) {
                this.setState({ data: result.data });
            }
        }
    }


    render() {
        const { classes } = this.props;
        const { data, param } = this.state;
        let datas = AppUtils.processList(data, 2);
        return (
            <MBack title={param && param.recomm_title ? param.recomm_title : ''}>
                <Grid className={classes.content}>
                    {
                        datas.length > 0 && datas.map((item, i) => (
                            <PreviewTwoItem key={i} data={item} />
                        ))
                    }
                    {
                        data.length == 0 && <NoMatch />
                    }
                </Grid>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        color: '#fff',
        position: 'fixed',
        right: 0
    },
    content: {
        padding: theme.spacing(2, 0, 0, 0)
    },
}))(MoreRecomm));